<script>
import httpService from "@/core/api/request";
export default {
  data: function() {
    return {
      designers: null,
      discountTypes: null,
      categories: null
    };
  },
  methods: {
    getDesigners: function() {
      let httpRequest = {
        module: "designers",
        params: ""
      };
      this.get(httpRequest)
        .then(designers => {
          this.designers = designers.data;
        })
        .catch(() => {
          this.designers = [];
        });
    },
    getDiscountTypes: function() {
      let httpRequest = {
        module: "discount_types",
        params: ""
      };
      this.get(httpRequest)
        .then(discountTypes => {
          this.discountTypes = discountTypes.data;
        })
        .catch(() => {
          this.discountTypes = [];
        });
    },
    getCategories: function() {
      let httpRequest = {
        params: "",
        module: "product_categories"
      };
      this.get(httpRequest)
        .then(categories => {
          this.categories = categories.data;
        })
        .catch(() => {
          this.categories = null;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/products/mixins.vue